import { dispatchLegacyAnalyticsEvent } from "@/utils/analytics";
import { FOUNDIT_CLICK } from "@/utils/events";
import { FoundItLink } from "@/types/foundIt";

/**
 * Dispatches analytics event for FoundItLinks clicks
 * @param link The FoundIt link that was clicked
 * @param asPath The current router path
 * @param pageType The type of page (browse, brand, etc.)
 * @param analyticsContext The context for analytics (e.g., "links")
 * @param totalLinks The total number of links displayed
 */
export const trackFoundItLinksClick = (
  link: FoundItLink,
  asPath: string,
  pageType: string,
  analyticsContext: string,
  totalLinks: number,
) => {
  const { Order, AnchorText, DestinationUrl } = link;

  const sourceUrl = asPath.split("#")[0];

  dispatchLegacyAnalyticsEvent(FOUNDIT_CLICK, {
    action: "foundit_click",
    foundItParam: `${sourceUrl}|${pageType}|${analyticsContext}|${Order}|${totalLinks}|${AnchorText}|${DestinationUrl}`,
    foundItLink: AnchorText,
  });
};
